<!-- HEADING PART -->
<p-card>

    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12 createnewbtn breadcrumbrightmenu">
            <div class="border-round-sm font-bold">
                <!-- <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
                <app-sdlcmenu></app-sdlcmenu> -->
                <button pTooltip="Help" tooltipPosition="left" aria-hidden="true" class="fa fa-question helpicon"
                    (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 14)">
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="loggedInOrgId == '0'" class="formgrid grid">
        <div class="field col-12" style="display:flex;justify-content:center;align-items:center;gap:10px">

            <label><b>Organisation</b></label>

            <p-dropdown [options]="organisationList" optionLabel="name" optionValue="orgid" [(ngModel)]="selectedOrgId"
                (onChange)="onOrgChange($event.value)" [filter]="true" appendTo="body" [showClear]="true"
                style="width:40%;min-width:250px">
            </p-dropdown>

        </div>
    </div>

    <div class=" mr-0">
        <p-table #dt [value]="tableData" [rows]="rows2" [scrollable]="true" scrollDirection="horizontal"
            scrollHeight="{{commonScrollHeight}}" [customSort]="true"
            [globalFilterFields]="['sno','numberofsigns','ctr','rid','productname','createdon','nam','uuid','documenttype','pdffilename']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            (onPage)="handlePageChange($event)" [rowsPerPageOptions]="paginatorArray" dataKey="rid"
            sortField="createdon" [sortOrder]="-1" [rowHover]="true" [showCurrentPageReport]="true" [first]="first2"
            [totalRecords]="totalRecords" paginatorLocale="fa-IR" [resizableColumns]="true" columnResizeMode="expand"
            [lazy]="true" (onLazyLoad)="callData($event)" [paginator]="tableData.length>0" responsiveLayout="scroll">
            <!-- search -->
            <ng-template pTemplate="caption">
                <div class="grid table-header">
                    <div class="col-12 md:col-10 sm:col-12 lg:col-10">
                        <span class=" p-input-icon-lft">
                            <i icon="pi pi-search"></i>
                            <input class="form-control" pInputText type="text" id="tablesearch"
                                (input)="dt.filterGlobal($any($event.target).value , 'contains')"
                                placeholder="Search in ESignature Records" class="tablesearch"
                                pTooltip="Enter Search Criteria" tooltipPosition="top" />
                        </span>
                    </div>
                    <div class="col-12 sm:col-2 md:col-2 sm:col-12 displayflex">
                        <span>
                            <div class="iconexcel" pTooltip="Download Excel Data" tooltipPosition="bottom"
                                style="cursor: pointer;" (click)="exceDownloadModel('full')"></div>
                        </span>
                        <span>
                            <div *ngIf="loggedInOrgId == '0'" class="iconexcel" pTooltip="Download Call Back Issue Data"
                                tooltipPosition="bottom" style="cursor: pointer;"
                                (click)="exceDownloadModel('trueCopy')"></div>
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 5px !important;">Action</th>
                    <ng-container *ngFor="let col of _selectedColumns">
                        <th [pSortableColumn]="col.field" *ngIf="col.isChecked" pResizableColumn>
                            {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>

                        </th>
                    </ng-container>
                </tr>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th>Action </th>
                    <!-- <th pResizableColumn pSortableColumn="sno">Sno<p-sortIcon field="sno"></p-sortIcon></th> -->
                    <th pResizableColumn pSortableColumn="closedflag">Status<p-sortIcon field="closedflag"></p-sortIcon>
                    </th>
                    <th *ngIf="loggedInOrgId == '0'" pResizableColumn pSortableColumn="orgName">
                        Organisation<p-sortIcon field="orgName"></p-sortIcon>
                    </th>
                    <th pResizableColumn pSortableColumn="uuid">UUID<p-sortIcon field="uuid"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="numberofsigns"># of Signs<p-sortIcon
                            field="numberofsigns"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="ctr">Signed<p-sortIcon field="ctr"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="rid">ID<p-sortIcon field="rid"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="productname">Module<p-sortIcon
                            field="productname"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="documenttype">Document Type<p-sortIcon
                            field="documenttype"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="pdffilename">PDF File Name<p-sortIcon
                            field="pdffilename"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="createdon">Created On<p-sortIcon
                            field="createdon"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="name">Created By<p-sortIcon field="name"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-data let-i="rowIndex">
                <tr>
                    <td style="width: 6px !important;">
                        <div style="display: flex; gap: 0px;">
                            <span class="actionItm" pTooltip="View" tooltipPosition="left"> <i class="fa fa-eye"
                                    (click)="show('View Esignature Record',data)"></i></span>&nbsp;
                        </div>
                    </td>
                    <!-- <td style="width: 5% !important;"  pTooltip="{{ i + 1 }}" [innerHTML]="highlight((i + 1).toString(), searchTerm)"></td> -->
                    <td style="width: 5% !important;" pTooltip="{{data.closedflag}}">
                        <i *ngIf="data['closedflag']=== 'Y'" pTooltip="Closed" tooltipPosition="left" class="fa fa-flag"
                            aria-hidden="true" style="color: green;"></i>
                        <i *ngIf="data['closedflag']!== 'Y'" pTooltip="Open" tooltipPosition="left" class="fa fa-flag"
                            aria-hidden="true" style="color: red;"></i>
                    </td>
                    <td *ngIf="loggedInOrgId == '0'" style="width: 23% !important;" pTooltip="{{data.orgName}}"
                        [innerHTML]="highlight(data.orgName,searchTerm)"></td>
                    <td style="width: 23% !important;" pTooltip="{{data.uuid}}"
                        [innerHTML]="highlight(data.uuid,searchTerm)">
                    </td>
                    <td style="width: 6% !important;" pTooltip="{{data.numberofsigns}}"
                        [innerHTML]="highlight(data.numberofsigns,searchTerm)"></td>
                    <td style="width: 5% !important;" pTooltip="{{data.ctr}}"
                        [innerHTML]="highlight(data.ctr,searchTerm)"></td>
                    <td style="width: 5% !important;" pTooltip="{{data.rid}}"
                        [innerHTML]="highlight(data.rid,searchTerm)"></td>
                    <td style="width: 6% !important;" pTooltip="{{data.productname}}"
                        [innerHTML]="highlight(data.productname,searchTerm)"></td>
                    <td style="width: 6% !important;" pTooltip="{{data.documenttype}}"
                        [innerHTML]="highlight(data.documenttype,searchTerm)"></td>
                    <td style="width: 16% !important;" pTooltip="{{data.pdffilename}}"
                        [innerHTML]="highlight(data.pdffilename,searchTerm)"></td>
                    <td style="width: 6% !important;" pTooltip="{{data.createdon}}"
                        [innerHTML]="highlight(data.createdon,searchTerm)"></td>
                    <td style="width: 9% !important;" pTooltip="{{data.name}}"
                        [innerHTML]="highlight(data.name,searchTerm)">
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="card" style="margin-top: -4px;" *ngIf="tableData.length==0">
        <p-card>
            <p style="text-align: center;">Data not found...</p>
        </p-card>
    </div>
</p-card>

<p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [modal]="true" [baseZIndex]="10000"
    [draggable]="true" [resizable]="false" position="top">
    <div class="dialog-content-min-excel" style=" text-align: center !important;">
        <div class="card">
            <p>{{excel_paragraph}}</p>
        </div>
    </div>
</p-dialog>